import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { Cookies } from "react-cookie";
import useWebSocket, { ReadyState } from 'react-use-websocket';
import ActualPNLCard from './ActualPNLCard';
import StatisticsCard from './StatisticsCard';
import TotalUser from "../../../assets/dashboard/TotalUser.jsx";
import KYC from "../../../assets/dashboard/KYC.jsx";
import Online from "../../../assets/dashboard/Online.jsx";
import Active from "../../../assets/dashboard/Active.jsx";
import Accounts from '../../../assets/dashboard/Accounts.jsx';

const Overview = ({ dashboardData }) => {
  const cookies = new Cookies();
  const [socketData, setSocketData] = useState(null);

  const { sendJsonMessage, lastJsonMessage } = useWebSocket(`wss://backend.rimglobal.trade/api/MTFiveAccount/ws?authorization=Bearer ${cookies.get('token')}`,
    { shouldReconnect: () => true, share: true }
  );

  useEffect(() => {
    setSocketData(lastJsonMessage?.data);
  }, [lastJsonMessage]);

  useEffect(() => {
    sendJsonMessage({ eventType: 'AdminLiveDashboard', action: "subscribe" });
    return () => {
      sendJsonMessage({ eventType: 'AdminLiveDashboard', action: "unsubscribe" });
    }
  }, [])

  const statisticsCards = [
    { title: 'Total A/C', value: socketData?.MT5TotalAccounts, icon: <TotalUser color="#7367F0" />, url: '/accounts', bgColor: "bg-[#E9E7FD]" },
    { title: 'Active A/C', value: socketData?.MT5ActiveAccounts, icon: <Active color="#00BAD1" />, url: '/accounts', bgColor: "bg-[#D6F4F8]" },
    { title: 'Pending A/C', value: dashboardData?.liveAccPending, icon: <Accounts color="#FF9F43" />, url: '/accounts', bgColor: "bg-[#FFF0E1]" },
    { title: 'Online Users', value: socketData?.MT5OnlineUsers, icon: <Online color="#28C76F" />, url: '/terminal_Online_Users', bgColor: "bg-[#DDF6E8]" },
    { title: 'Pending KYC', value: dashboardData?.kycPending, icon: <KYC color="#FF4C51" />, url: '/kyc?filter=Pending', bgColor: "bg-[#FFE2E3]" },
  ];

  return (
    <>
      <div className="xl:col-span-5 col-span-6 xl:order-2 order-1 border-2 border-light rounded-[10px] p-5 cursor-pointer order-2">
        <div className="flex flex-col gap-5 h-full">
          <h2 className="text-title font-semibold">Statistics</h2>

          <div className="grid md:grid-cols-3 xl:grid-cols-5 gap-5">
            {statisticsCards?.map((card, index) => (
              <Link to={card?.url} key={index}>
                <StatisticsCard {...card} />
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="xl:col-span-1 col-span-6 order-2 xl:order-1">
        <ActualPNLCard amount={socketData?.MT5ActualProfitLoss} />
      </div>

    </>
  )
}

export default Overview